import React from "react";
import { Router, Route } from "react-router-dom";
import Login from "./login/Login";
import history from "../history";
import Bottom from "./navbar/Bottom";
import Dashboard from "./dashboard/Dashboard";
import { connect } from "react-redux";
import AkmList from "./dashboard/content/akm/AkmList";
import FormProfilCbt from "./dashboard/content/akm/FormProfilCbt";
import FormSubProfil from "./dashboard/content/akm/FormSubProfil";
import MgtSoalAkm from "./dashboard/content/banksoal/MgtSoalAkm";
import AddSoal from "./dashboard/content/banksoal/AddSoal";
import AkmJadwal from "./dashboard/content/akm/jadwal/AkmJadwal";
import SekolahSnmptn from "./dashboard/content/snmptn/mgtSekolah/SekolahSnmptn";
import AkmSoal from "./dashboard/content/akm/AkmSoal";
import Menu from "./dashboard/content/setting/Menu";
import PreviewSoal from "./dashboard/content/akm/PreviewSoal";
import Report from "./dashboard/content/report/akm/Report";
import ListSekolahAkm from "./dashboard/content/report/akm/ListSekolahAkm";
import DownloadSoal from "./dashboard/content/akm/DownloadSoal";
import ReportSiswa from "./dashboard/content/report/akm/ReportSiswa";
import Account from "./dashboard/content/account/Account";
import AccountForm from "./dashboard/content/account/AccountForm";
import DeleteSiswa from "./dashboard/content/admin/import/DeleteSiswa";
import SetPointSbmptn from "./dashboard/content/admin/profil/SetPointSbmptn";

// ADMIN INTERNAL
import ImportSekolah from "./dashboard/content/admin/import/ImportSekolah";
import ImportSiswa from "./dashboard/content/admin/import/ImportSiswa";
import ImportProdi from "./dashboard/content/admin/import/ImportProdi";
import ListProdiUnik from "./dashboard/content/admin/listprodi/ListProdiUnik";
import ListProdi from "./dashboard/content/admin/listprodi/ListProdi";

// RND
import ImportSoal from "./dashboard/content/banksoal/ImportSoal";
import MgtProfil from "./dashboard/content/admin/profil/MgtProfil";
import JadwalProfilCbt from "./dashboard/content/admin/profil/JadwalProfilCbt";
import PaketProgram from "./dashboard/content/admin/paketprogram/PaketProgram";
import DownloadSoalToo from "./dashboard/content/admin/profil/DownloadSoalToo";
import JadwalProgramHub from "./dashboard/content/admin/paketprogram/JadwalProgramHub";
import MatapelajaranSnmptn from "./dashboard/content/admin/matapelajaran/MatapelajaranSnmptn";

// TS
import Voucher from "./dashboard/content/admin/aktivasi/Voucher";
import SearchDetailAktivasiSiswa from "./dashboard/content/admin/aktivasi/SearchDetailAktivasiSiswa";

// KEU
import PenjualanVoucher from "./dashboard/content/admin/penjualan/PenjualanVoucher";
import RekapPenjualan from "./dashboard/content/admin/penjualan/RekapPenjualan";

import MgtPsepSekolah from "./dashboard/content/admin/psep/MgtPsepSekolah";
import MgtPsepSiswa from "./dashboard/content/admin/psep/MgtPsepSiswa";

class App extends React.Component {
  render() {
    return (
      <div>
        <Router history={history}>
          <Route path="/" exact component={Login} />
          <Route path="/login" exact component={Login} />
          <Route path="/dashboard" component={Dashboard} />
          <Route path="/akm" component={AkmList} />
          <Route path="/cbt/post/:tipeCbt" component={FormProfilCbt} />
          <Route path="/cbt/mapel" component={FormSubProfil} />
          <Route path="/cbt/addsoal" component={AkmSoal} />
          <Route path="/soal" component={MgtSoalAkm} />
          <Route path="/soal_akm" component={MgtSoalAkm} />
          <Route path="/addsoal" component={AddSoal} />
          <Route path="/jadwal_akm" component={AkmJadwal} />
          <Route path="/snmptnsekolah" component={SekolahSnmptn} />
          <Route path="/menu" component={Menu} />
          <Route path="/soal-preview" component={PreviewSoal} />
          {/* <Route path="/rptakm/:idJadwal/:idSekolah/:idKelas/:idKelasParalel" component={Report} /> */}
          {/* <Route path="/rptakmsiswa/:idSiswa/:idJadwal/:idSekolah/:idKelas/:idKelasParalel" component={ReportSiswa} /> */}
          <Route path="/rptakm" component={Report} />
          <Route path="/rptakmsiswa" component={ReportSiswa} />
          <Route path="/sekolahakm" component={ListSekolahAkm} />
          <Route path="/download-soal" component={DownloadSoal} />
          <Route path="/delsis" component={DeleteSiswa} />
          <Route path="/sbmptn/soal" component={SetPointSbmptn} />

          {/* ADMIN INTERNAL */}
          <Route path="/imsekolah" component={ImportSekolah} />
          <Route path="/imsiswa" component={ImportSiswa} />
          <Route path="/improdi" component={ImportProdi} />
          <Route path="/listprodiunik" component={ListProdiUnik} />
          <Route path="/listprodi" component={ListProdi} />

          {/* RND */}
          <Route path="/soal_upload" component={ImportSoal} />
          <Route path="/mgttoo" component={MgtProfil} />
          <Route path="/mgtagcu" component={MgtProfil} />
          <Route path="/mgtpeminatan" component={MgtProfil} />
          <Route path="/mgtpeminatan" component={MgtProfil} />
          <Route path="/mgtpemetaan" component={MgtProfil} />
          <Route path="/mgtpemetaan2" component={MgtProfil} />
          <Route path="/mgtpemetaan3" component={MgtProfil} />
          <Route path="/mgtsbmptn" component={MgtProfil} />
          <Route path="/mgtensa" component={MgtProfil} />
          <Route path="/mgtjadwalcbt" component={JadwalProfilCbt} />
          <Route path="/mgtpp" component={PaketProgram} />
          <Route path="/download-soal-too" component={DownloadSoalToo} />
          <Route path="/mgtjadwalprogram" component={JadwalProgramHub} />
          <Route path="/mapelsnmptn" component={MatapelajaranSnmptn} />

          {/* TS */}
          <Route path="/mgtvoucher" component={Voucher} />
          <Route path="/searchdetailaktivasisiswa" component={SearchDetailAktivasiSiswa} />

          {/* KEU */}
          <Route path="/penjualanvoucher" component={PenjualanVoucher} />
          <Route path="/rekappenjualan" component={RekapPenjualan} />

          <Route path="/mgtakun" component={Account} />
          <Route path="/addeditakun/:idRole/:level" component={AccountForm} />

          <Route path="/profil_qs" component={AkmList} />
          <Route path="/jadwal_qs" component={AkmJadwal} />

          <Route path="/mgtpsepsekolah" component={MgtPsepSekolah} />
          <Route path="/mgtpsepsiswa" component={MgtPsepSiswa} />
        </Router>
        <Bottom />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};
export default connect(mapStateToProps)(App);
